<quill-editor class="editor" [formControl]="control" [placeholder]="'Start typing...'" [modules]="modules" bounds="self"></quill-editor>
